import React from "react"

import { joinClasses, useClasses } from "../globals";

import {
  Box,
  Collapse,
  Link,
  Typography
} from "@material-ui/core"
import { Alert } from "@material-ui/lab"


export const NoTeams = ({ email }) => {
  const classes = useClasses()

  return (
    <React.Fragment>
      <Box
        className={joinClasses(
          classes._Padding,
          classes._Flex,
          classes._FlexDirectionColumn
        )}
      >
        <Box className={classes._Margin}>
          <Collapse in>
            <Alert severity="error">
              <Typography>
                You are not enrolled in any sessions for this simulation. Contact a facilitator or learning administrator for more information.
              </Typography>
            </Alert>
          </Collapse>
        </Box>
      </Box>
    </React.Fragment>
  )
}

NoTeams.title = "No Sessions Found";